.bx{justify-content:flex-end;}